import api from '@/shared/api';

export const findAll = () => {
  return api.get('/newspapers', {})
  .then(({ data }) => data)
  .catch(error => ({ list: [], meta: {}, error }));
};